import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfSD(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "SD", key: "sd", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.sd_code ?? "-",
    sd: item.sd_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="SD" />;
}
